export const Header = (props) => {
  return (
    <header id='header'>
      <div className='intro'>
        <video id="background-video" autoplay="autoplay" loop muted poster="../landing.png" >
          <source src="landing.mp4" type="video/mp4" />
        </video>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-8 col-md-offset-2 intro-text'>
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : 'Loading'}</p>
                <a
                  href='#about'
                  className='btn btn-custom btn-lg page-scroll'
                >
                  {props.data ? props.data.button : 'Loading'}
                </a>{' '}
              </div>
            </div>
          </div>
        </div>
      </div>

    </header>
  )
}
